import React from 'react';
import SubjectPage from './../subjects/SubjectPage';



function Formulas() {

  const pageTitleText = "NEET Formula ";


  return (
    <>
  

      <SubjectPage 
        name={pageTitleText} 
        link="formulas" 
        type="formula"
      />
    </>
  );
}

export default Formulas;